import type { AdminUserDetail } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { UserAccountCard } from './user-account-card';
import { UserActivityCard } from './user-activity-card';
import { UserLoginMethodsCard } from './user-login-methods-card';

interface UserDetailProps {
  readonly user: AdminUserDetail;
}

/** 어드민 회원 상세 — 왼쪽에 계정 정보, 오른쪽에 로그인 수단·활동을 쌓는다. 읽기 전용이고 차단·해제는 목록에서 한다. */
export const UserDetail = ({ user }: UserDetailProps): ReactElement => (
  <div className="grid gap-5 lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)]">
    <UserAccountCard user={user} />
    <div className="flex flex-col gap-5">
      <UserLoginMethodsCard user={user} />
      <UserActivityCard activity={user.activity} />
    </div>
  </div>
);
